import React from "react"
import { Link } from "gatsby"
import  Sidebar from "./Sidebar"
import { Helmet } from "react-helmet"

const ListLink = props => (
    <li style={{ display: `inline-block`, marginRight: `1rem` }}>
        <Link to={props.to}>{props.children}</Link>
    </li>
)
const PageHeader = props => (
    <header>
        <h2>{props.title}</h2>
    </header>
)

const PageFooter = props => (
    <div id="footer">
        <ul className="copyright">
            <li>&copy; Rohan. All rights reserved.</li>
        </ul>
    </div>
)

export default ({ children, props }) => (
    
    <div className="mainpage">
        <Sidebar />
        {/* <PageHeader title={props.title} /> */}

        <div id="main">
        {children}
        </div>

        <PageFooter />

        <Helmet>
            <script data-ad-client="ca-pub-2308229493491697" async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>
        </Helmet>
    </div>

)